'use strict';

export function init() {
    const globalNav = document.querySelector('.js-global-navigation');
    const globalHeader = document.querySelector('.global-header');
    const scrollContainer = document.querySelector('.js-global-navigation');

    if (globalNav && globalHeader && scrollContainer) {
        var myScrollFunc = function() {
            console.log('Scroll event triggered');
            var y = scrollContainer.scrollTop;
            console.log('Scroll Position:', y);

            if (globalNav.classList.contains('is-toggled')) {
                if (y >= globalHeader.offsetHeight - 50 ) {
                    globalHeader.classList.add('navigation-scroll');
                    console.log('Adding class navigation-scroll');
                } else {
                    globalHeader.classList.remove('navigation-scroll');
                    console.log('Removing class navigation-scroll');
                }
            } else {
                console.log('Global Nav does not have is-toggled class');
            }
        };

        scrollContainer.addEventListener('scroll', myScrollFunc, { passive: true });
    }
}
